module.exports = __webpack_public_path__ + "img/_refresh.b1a974c7.svg";